function updateAndRevertText(originalText, updatedText, updatedText1, interval) {
  const targetElement = document.querySelector('.content-item-custom-text .custom-text.item');
  if (!targetElement) {
    console.error('Target element not found.');
    return;
  }

  let currentState = 0; // 0 = original, 1 = updatedText, 2 = updatedText1

  // Function to handle the end of the transition
  function handleTransitionEnd() {
    if (currentState === 1) {
      targetElement.innerHTML = updatedText; // Update to first updated text
    } else if (currentState === 2) {
      targetElement.innerHTML = updatedText1; // Update to second updated text
    } else {
      targetElement.innerHTML = originalText; // Revert to original text
    }
    targetElement.style.transition = 'opacity 500ms ease';
    targetElement.style.opacity = '1'; // Fade in
  }

  targetElement.addEventListener('transitionend', handleTransitionEnd);

  setInterval(() => {
    targetElement.style.transition = 'opacity 500ms ease';
    targetElement.style.opacity = '0'; // Fade out

    // Update the state
    currentState = (currentState + 1) % 3; // Cycle through 0, 1, 2

    // Trigger the transition end manually after a short delay
    setTimeout(() => {
      handleTransitionEnd();
    }, 500); // Match this delay with the fade-out duration
  }, interval);
}

// Get the text content from the elements
const originalText = document.querySelector('.content-item-custom-text .custom-text.item').innerHTML;
const updatedText = document.querySelector('.content-item-custom-text .custom-text.item1').innerHTML;
const updatedText1 = document.querySelector('.content-item-custom-text .custom-text.item2').innerHTML;
const interval = 3000; // Change this value to adjust the interval (in milliseconds)

updateAndRevertText(originalText, updatedText, updatedText1, interval);